angular.module('trainerWebApp.services').factory('authView', ['Auth', 'mtypes', 'accountFeatures', '$rootScope',
  function (Auth, mtypes, accountFeatures, $rootScope) {

    var tabs = {
      manageTab: {name: 'manage', title: 'Manage', contentSrc: 'pages/series/seriesManage.html', selected: false},
      traineesTab: {name: 'trainees', title: 'Trainees', contentSrc: 'pages/series/seriesTrainees.html', selected: false,
        subSelection: [
          {name: 'addExistingTrainees', contentSrc: 'pages/users/inviteTrainees.html'},
          {name: 'addNewUser', contentSrc: 'pages/users/addNewUser.html'},
          {name: 'addYammerUsers', contentSrc: 'pages/yammer/yammerTrainees.html'},
          {name: 'importXls', contentSrc: 'pages/users/xls/xls.html'}
        ]},
      customizeTab: {name: 'customize', title: 'Customize', contentSrc: 'pages/series/seriesCustomize.html', selected: false,
        subSelection: [
          {name: 'emails', contentSrc: 'pages/series/seriesEmails.html'}
        ]},
      customizeManagerTab: {name: 'customize', title: 'Customize', contentSrc: 'pages/series/seriesCustomizeManager.html', selected: false}
    };

    function isAdministrator() {
      return Auth.userRole() == mtypes.userRole.administrator;
    }

    function isTrainer() {
      return Auth.userRole() == mtypes.userRole.trainer;
    }

    function isManager() {
      return Auth.userRole() == mtypes.userRole.manager;
    }

    function isTeamLead() {
      return Auth.userRole() == mtypes.userRole.teamLead;
    }

    function isReporter() {
      return Auth.userRole() == mtypes.userRole.reporter;
    }

    function getAdvancedTrialDaysLeft() {
      if (!accountFeatures.advancedTierDaysLeft)
        return null;
      return accountFeatures.advancedTierDaysLeft;
    }

    function isInFeatureTrial() {
      var daysLeft = getAdvancedTrialDaysLeft();
      if (!daysLeft)
        return false;
      return daysLeft >= 0;
    }

    return {
      getTabs: function () {
        if (isAdministrator())
          return [tabs.manageTab, tabs.customizeTab, tabs.traineesTab];
        else if (isTrainer())
          return [tabs.manageTab, tabs.customizeTab, tabs.traineesTab];
        else if (isManager())
          return [tabs.customizeManagerTab, tabs.traineesTab];
        else
          return [tabs.traineesTab];
        return [];
      },

      isAdministrator: isAdministrator,
      isTrainer: isTrainer,
      isManager: isManager,
      isReporter: isReporter,

      isTrial: function () {
        return accountFeatures.pricingType == mtypes.pricingType.trial;
      },

      isInFeatureTrial: isInFeatureTrial,

      getAdvancedTrialDaysLeft: getAdvancedTrialDaysLeft,

      showGoodData: function () {
        return $rootScope.mfConfig.features.indexOf(mtypes.featureEntry.goodDataDashboardLight) > -1
          || $rootScope.mfConfig.features.indexOf(mtypes.featureEntry.goodDataDashboardHeavy) > -1
          || $rootScope.mfConfig.trialFeatures.indexOf(mtypes.featureEntry.goodDataDashboardLight) > -1
          || $rootScope.mfConfig.trialFeatures.indexOf(mtypes.featureEntry.goodDataDashboardHeavy) > -1;
      },

      getGoodDataUrlForSeriesReport: function (seriesId) {
        if (!this.showGoodData())
          return null;
        return accountFeatures.getGoodData().seriesReportUrlTemplate.replace('{0}', seriesId);
      },

      getGoodDataUrlForTraineesDashboard: function () {
        if (!this.showGoodData())
          return null;
        return accountFeatures.getGoodData().traineesDashboardUrl;
      },

      getGoodDataUrlForClientDashboard: function () {
        if (!this.showGoodData())
          return null;
        return accountFeatures.getGoodData().clientDashboardUrl;
      },

      getManageAccountLink: function () {
        if (this.isAdministrator())
          return 'redirect';

        return 'modal';
      },

      getListOfRolesCurrentUserCanAdd: function () {
        if (isAdministrator()) {
          if (!_.contains(accountFeatures.features, mtypes.featureEntry.trainerPermissions)) {
            return [mtypes.userRole.trainee, mtypes.userRole.administrator];
          }

          return [
            mtypes.userRole.trainee,
            mtypes.userRole.reporter,
            mtypes.userRole.teamLead,
            mtypes.userRole.manager,
            mtypes.userRole.trainer,
            mtypes.userRole.administrator
          ];
        }

        return [];
      },

      getTierDescription: function () {
        return accountFeatures.tierName;
      },

      getTrialDaysLeft: function () {
        if (accountFeatures.trialDaysLeft == null)
          return null;
        if (accountFeatures.trialDaysLeft < 0)
          return null;
        return accountFeatures.trialDaysLeft;

      },

      showUserPermissionsManagement: function () {
        return isAdministrator() &&
          accountFeatures.features.indexOf(mtypes.featureEntry.userMgmtRestrictions) != -1;
      },

      isActiveAdvancedtrial: function () {
        if (isInFeatureTrial()) {
          return getAdvancedTrialDaysLeft() > 0;
        }
        return false;
      }
    }
  }]);
